import axiosInstance from '../../../config/axiosInstance';
import { JobRecurValidation } from "../View/Validation/JobRecurValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
 
  event.preventDefault();
  const formErrors = JobRecurValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.UserID=UserID;
      const response = await axiosInstance.post(`/Job/CreateJobRecur`, formData);
      setFormData({
        snt_RecurType: 0,
        snt_RecurFrequency: 0,
        snt_FrequencyAmount: 0,
        snt_RecurEntries: 0,
        dt_Begin:""
        // Reset other fields as needed
      });
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };